import { render, staticRenderFns } from "./ModalContainer.vue?vue&type=template&id=1a1ce6d0&scoped=true&"
import script from "./ModalContainer.vue?vue&type=script&lang=ts&"
export * from "./ModalContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ce6d0",
  null
  
)

export default component.exports